import { useCallback, useEffect, useState, useRef } from 'react';
import type { CascadingSelectState } from '@atlassian/jira-jql-builder-basic-cascading-select/src/common/types.tsx';
import type { useHydrationQueryLoaderQuery$data } from '@atlassian/jira-relay/src/__generated__/useHydrationQueryLoaderQuery.graphql';
import type { JQLBuilderUI243BadPattern$data } from '@atlassian/jira-relay/src/__generated__/JQLBuilderUI243BadPattern.graphql';

export const useSelectedValues = (
	hydratedData: useHydrationQueryLoaderQuery$data | JQLBuilderUI243BadPattern$data,
	selectedOptionsFromHydration: CascadingSelectState | undefined,
) => {
	const prevHydrationData = useRef<
		useHydrationQueryLoaderQuery$data | JQLBuilderUI243BadPattern$data
	>(hydratedData);
	const [hydrated, setHydrated] = useState(true);

	// Allow optimistic updates when a value is selected while hydration is taking place
	const [optimisticValues, setOptimisticValues] = useState<CascadingSelectState | undefined>();

	// Only flag values as hydrated after a data change
	useEffect(() => {
		if (!hydrated && hydratedData !== prevHydrationData.current) {
			setHydrated(true);
		}
		prevHydrationData.current = hydratedData;
	}, [hydrated, hydratedData]);

	const setSelectedValues = useCallback((values: CascadingSelectState) => {
		setHydrated(false);
		setOptimisticValues(values);
	}, []);

	const selectedValues =
		!hydrated && optimisticValues ? optimisticValues : selectedOptionsFromHydration;
	return [selectedValues, setSelectedValues] as const;
};
